export const config = {
  fallbackImage: '/assets/images/fallback-image.jpg',
  minBookingDays: 31,
};
